export const hash = (file: File) => `${file.name}:${file.type}:${file.size}`;
